import { useContext } from 'react';

import { DisclosureDeliveryContext } from '../DisclosureDeliveryContext';

const useDisclosureDelivery = () => useContext(DisclosureDeliveryContext);

export default useDisclosureDelivery;
